import styled from 'styled-components';

const Buttons = (ComponentName) => styled(ComponentName)`
  &.ant-btn {
    display: inline-block;
    margin-bottom: 0;
    font-weight: bold;
    text-align: center;
    -ms-touch-action: manipulation;
    touch-action: manipulation;
    cursor: pointer;
    background-image: none;
    border: 1px solid var(--orochimaru);
    white-space: nowrap;
    line-height: 14px;
    padding: 0 20px;
    font-size: 15px;
    height: 50px;
    -webkit-user-select: none;
    -moz-user-select: none;
    -ms-user-select: none;
    user-select: none;
    position: relative;
    color: var(--zambezi);
    transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

    @media only screen and (min-width: 768px) and (max-width: 1550px) {
      padding: 0 15px;
      height: 45px;
    }
    @media screen and (max-width: 1024px) {
      height: 40px;
      line-height: 1.4;
    }

    &:hover,
    &:focus {
      border-color: var(--bleuchatel-blue);
      color: var(--bleuchatel-blue);
    }

    > .anticon + span,
    > span + .anticon {
      margin: 0 0 0 0.5em;
    }

    .anticon-right,
    .anticon-left {
      transform: rotate(0);
    }

    &.ant-btn-primary {
      background-image: ${(props) => props['hideBackGroundImage'] && 'none'};

      border-color: var(--bleuchatel-blue);

      &:hover,
      &:focus {
        background-color: var(--blue-chaos);
        border-color: var(--blue-chaos);
        color: var(--white);
      }
    }

    &.ant-btn-sm {
      padding: 0 15px;
      height: 28px;
      font-size: 12px;

      &.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline) {
        padding: 0 15px 0 24px;
        .anticon {
          margin: 0 0 0 -17px;
        }
      }
    }

    &.ant-btn-lg {
      padding: 0 35px;
      font-size: 14px;
      height: 42px;
    }

    &.ant-btn-primary {
      color: var(--white);
    }

    &.ant-btn-dashed {
      border-style: dashed;
      border-color: var(--bleached-silk);

      &:hover,
      &:focus {
        color: var(--bleuchatel-blue);
        border-color: var(--bleuchatel-blue);
      }
    }

    &.ant-btn-link {
      border: none;
      padding: 0;
      height: auto;
    }

    &.ant-btn-danger {
      background-color: var(--grapefruit);
      border-color: var(--grapefruit);
      color: var(--white);

      &:hover,
      &:focus {
        background-color: var(--safflower-red);
        border-color: var(--safflower-red);
      }

      &.ant-btn-background-ghost {
        color: var(--grapefruit);
        background-color: transparent;
        border-color: var(--grapefruit);

        &:hover,
        &:focus {
          color: var(--safflower-red);
          border-color: var(--safflower-red);
        }
      }
    }

    &.ant-btn-warning {
      background-color: var(--question-mark-block);
      border-color: var(--question-mark-block);
      color: var(--white);

      &:hover,
      &:focus {
        background-color: var(--amber);
        border-color: var(--amber);
      }
    }

    &.ant-btn-success {
      background-color: var(--go-green);
      border-color: var(--go-green);
      color: var(--white);

      &:hover,
      &:focus {
        background-color: var(--go-green);
        border-color: var(--go-green);
      }
    }

    &.ant-btn-circle,
    &.ant-btn-circle-outline {
      width: 50px;
      padding: 0;
      font-size: 20px;
      border-radius: 50%;
      height: 50px;

      &.ant-btn-sm {
        padding: 0;
        height: 28px;
        width: 28px;
        font-size: 12px;
      }

      &.ant-btn-lg {
        padding: 0;
        font-size: 14px;
        height: 42px;
        width: 42px;
      }
    }

    &.ant-btn-round {
      .anticon {
        margin-right: 5px;
      }
    }

    &.type-one {
      background-color: var(--ruthless-empress);
      border-color: var(--ruthless-empress);
      color: var(--white);
      &:hover {
        background-color: rgba(var(--ruthless-empressRGB), 0.8);
        border-color: rgba(var(--ruthless-empressRGB), 0.8);
      }
    }
    &.type-two {
      background-color: var(--simply-peachy);
      border-color: var(--simply-peachy);
      color: var(--white);
      &:hover {
        background-color: rgba(var(--simply-peachyRGB), 0.8);
        border-color: rgba(var(--simply-peachyRGB), 0.8);
      }
    }

    &.ant-btn.disabled,
    &.ant-btn[disabled],
    &.ant-btn.disabled:hover,
    &.ant-btn[disabled]:hover,
    &.ant-btn.disabled:focus,
    &.ant-btn[disabled]:focus,
    &.ant-btn.disabled:active,
    &.ant-btn[disabled]:active,
    &.ant-btn.disabled.active,
    &.ant-btn[disabled].active {
      color: var(--desired-dawn);
      background-color: var(--lynx-white);
      border-color: var(--orochimaru);
      cursor: not-allowed;
    }

    &.ant-btn-loading:not(.ant-btn-circle):not(.ant-btn-circle-outline)
      .anticon {
      margin: 0 0 0 -14px;
    }

    &.isoButton {
      display: inline-block;
      margin-bottom: 0;
      font-weight: 500;
      text-align: center;
      -ms-touch-action: manipulation;
      touch-action: manipulation;
      cursor: pointer;
      background-image: none;
      border: 0;
      white-space: nowrap;
      line-height: 1.5;
      padding: 0 25px;
      font-size: 13px;
      border-radius: 4px;
      height: 35px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      position: relative;
      color: var(--white);
      background-color: var(--bleuchatel-blue);
      transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

      &:hover,
      &:focus {
        background-color: var(--lightish-blue);
      }

      &.isoBtnSm {
        padding: 0 15px;
        height: 28px;
        font-size: 12px;
      }

      &.isoBtnLg {
        padding: 0 35px;
        font-size: 14px;
        height: 42px;
      }
    }
  }

  + .ant-btn-group {
    margin-left: -1px !important;
    margin-right: 0 !important;
  }
`;

const RadioButtons = (ComponentName) => styled(ComponentName)`
  .ant-radio-button-wrapper {
    height: 35px;
    line-height: 33px;
    color: var(--zambezi);
    border: 1px solid var(--orochimaru);
    border-left: 0;
    background: var(--white);
    padding: 0 20px;

    &:hover,
    &.ant-radio-button-wrapper-focused {
      color: var(--bleuchatel-blue);
    }

    &.ant-radio-button-wrapper-checked {
      background: var(--white);
      border-color: var(--bleuchatel-blue);
      color: var(--bleuchatel-blue);
      box-shadow: -1px 0 0 0 var(--bleuchatel-blue);
    }
  }
`;

const ButtonsGroup = (ComponentName) => styled(ComponentName)`
  &.ant-btn-group {
    .ant-btn {
      margin: 0;
      margin-right: 0;
      display: inline-block;
      margin-bottom: 0;
      font-weight: 500;
      text-align: center;
      -ms-touch-action: manipulation;
      touch-action: manipulation;
      cursor: pointer;
      background-image: none;
      border: 1px solid transparent;
      border-color: var(--bleached-silk);
      white-space: nowrap;
      line-height: 1.5;
      padding: 0 8px;
      font-size: 14px;
      border-radius: 0;
      height: 36px;
      -webkit-user-select: none;
      -moz-user-select: none;
      -ms-user-select: none;
      user-select: none;
      position: relative;
      transition: all 0.3s cubic-bezier(0.215, 0.61, 0.355, 1);

      &:hover,
      &:focus {
        border-color: var(--bleuchatel-blue);
      }

      &.ant-btn-dashed {
        border-style: dashed;

        &:hover,
        &:focus {
          border-color: var(--bleuchatel-blue);
        }
      }

      &.ant-btn-primary {
        border-color: var(--bleuchatel-blue);

        &:hover,
        &:focus {
          border-color: var(--blue-chaos);
        }
      }
    }

    > .ant-btn:first-child:not(:last-child) {
      border-radius: 4px 0 0 4px;
    }

    > .ant-btn:last-child:not(:first-child) {
      border-radius: 0 4px 4px 0;
    }

    .ant-btn-primary:last-child:not(:first-child),
    .ant-btn-primary + .ant-btn-primary {
      border-left-color: var(--lightish-blue);
      border-right-color: var(--bleuchatel-blue);
    }

    .ant-btn-primary:first-child:not(:last-child) {
      border-left-color: var(--bleuchatel-blue);
      border-right-color: var(--lightish-blue);
    }

    .ant-btn + .ant-btn,
    + .ant-btn {
      margin-left: -1px !important;
      margin-right: 0 !important;
    }

    &.ant-btn-group-lg {
      > .ant-btn {
        padding: 0 35px;
        font-size: 14px;
        height: 42px;
      }
    }

    &.ant-btn-group-sm {
      > .ant-btn {
        padding: 0 15px;
        height: 28px;
        font-size: 12px;
      }
    }
  }

  &.ant-btn-group + &.ant-btn-group {
    margin-left: -1px !important;
    margin-right: 0 !important;
  }
`;

const GhostButtons = (ComponentName) => styled(ComponentName)`
  .ant-btn-background-ghost {
    background: transparent !important;
    border-color: var(--white);
    color: var(--white);

    &.ant-btn-primary {
      color: var(--bleuchatel-blue);
      background-color: transparent;
      border-color: var(--bleuchatel-blue);
    }
  }
`;

export { Buttons, ButtonsGroup, RadioButtons, GhostButtons };
